import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styles from '../css/RegisterToast.module.css';

const RegisterToast = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [visible, setVisible] = useState(false);
  const [hiding, setHiding] = useState(false);

  useEffect(() => {
    if (isAuthenticated) return;
    if (sessionStorage.getItem('reg_toast_dismissed')) return;

    const timer = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(timer);
  }, [isAuthenticated]);

  const dismiss = () => {
    setHiding(true);
    setTimeout(() => {
      setVisible(false);
      sessionStorage.setItem('reg_toast_dismissed', '1');
    }, 250);
  };

  if (!visible || isAuthenticated) return null;

  return (
    <div className={`${styles.toast} ${hiding ? styles.hiding : ''}`}>
      <div className={styles.header}>
        <p className={styles.title}>Зарегистрируйтесь — это бесплатно!</p>
        <button className={styles.close} onClick={dismiss} aria-label="Закрыть">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className={styles.perks}>
        <span className={styles.perk}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          История просмотров
        </span>
        <span className={styles.perk}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
          Добавлять в избранное
        </span>
        <span className={styles.perk}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
          </svg>
          Закладки и удобный просмотр
        </span>
      </div>

      <Link to="/auth/register" className={styles.btn} onClick={dismiss}>
        Зарегистрироваться
      </Link>
    </div>
  );
};

export default RegisterToast;
